import {
  CampaignUpdatedEvent,
  CrmListingCreatedEvent,
  RexListingCreatedEvent,
} from 'types/pushNotifications';

export const handleCampaignUpdated = async (
  event: CampaignUpdatedEvent,
  invalidateCampaignScopedQueries: (campaignId: string) => Promise<void>,
  invalidateSelectedCampaign: (campaignId: string) => Promise<void>,
  invalidateQueriesByAgencyId: ((agencyId: string) => Promise<void>)[]
) => {
  if (!event.agencyId) return;
  if (!event.campaignId) return;

  await Promise.all([
    invalidateCampaignScopedQueries(event.campaignId),
    invalidateSelectedCampaign(event.campaignId),
    ...invalidateQueriesByAgencyId.map((fn) => fn(event.agencyId)),
  ]);
};

export const handleRexListingCreated = async (
  event: RexListingCreatedEvent,
  invalidateCampaignListing: (campaignId: string) => Promise<void>,
  invalidateCrmCampaignListing: (agencyId: string, campaignId: string) => Promise<void>
) => {
  if (!event.campaignId) return;

  await invalidateCampaignListing(event.campaignId);

  // Older Campaigns hosts only send the Rex notification during rollout.
  if (event.agencyId) {
    await invalidateCrmCampaignListing(event.agencyId, event.campaignId);
  }
};

export const handleCrmListingCreated = async (
  event: CrmListingCreatedEvent,
  invalidateCrmCampaignListing: (agencyId: string, campaignId: string) => Promise<void>
) => {
  if (!event.agencyId || !event.campaignId) return;

  await invalidateCrmCampaignListing(event.agencyId, event.campaignId);
};
